export const API_PATH_apiAuthBasicSignInV2Get = '/services/authentication/sign-in-v2';
